<template>
  <div class="right-box">
    <div class="wechart-box">
      <p class="title">相关文章</p>
      <div class="article-cont">
        <div
          v-for="(item, i) in ArticleList"
          :key="i"
          class="article-info"
          @click="detail(item)"
        >
          <div class="img">
            <img
              :src="item.cover_url"
              alt
              v-if="typeof item.cover_url == 'string'"
            />
            <img :src="item.cover_url[0]" alt v-else />
          </div>
          <div class="cont">{{ item.title }}</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { getAboutArticle } from "@/api/public";
export default {
  props: {
    child: {
      type: [String, Number], //可指定接收类型，如:Array.
      default: "" //可设置默认值
    }
  },
  data() {
    return {
      ArticleList: []
    };
  },
  methods: {
    // 文章详情
    detail(scope) {
      // this.resetSetItem("isActive", 0);
      if (scope.article_type == "sound" || scope.article_type == "voice") {
        this.$router.push({
          name: "hot_detail",
          params: { id: scope.id }
        });
      } else {
        this.$router.push({
          name: "article_detail",
          params: { id: scope.id }
        });
        location.reload();
      }
    }
  },
  created() {
    // 相关文章
    var id = this.child.toString();
    getAboutArticle(id).then(res => {
      this.ArticleList = res.data.data;
    });
  }
};
</script>
<style lang="scss" scoped>
.right-box {
  background: #fff;
  text-align: center;
  font-size: 16px;
  margin-bottom: 30px;
  .wechart-box {
    padding: 30px;
    p {
      line-height: 24px;
      font-weight: bold;
    }
    .article-cont {
      .article-info {
        display: flex;
        justify-content: space-between;
        margin-top: 30px;
        cursor: pointer;
        .img {
          margin-right: 20px;
          width: 42%;
          height: 60px;
          img {
            width: 100%;
            height: 100%;
            object-fit: cover;
          }
        }
        .cont {
          width: 52%;
          text-align: left;
          text-overflow: -o-ellipsis-lastline;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 3;
          -webkit-box-orient: vertical;
          line-height: 20px;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/aboutArticle.vue